import { render, staticRenderFns } from "./add-ticket.vue?vue&type=template&id=50ed0814&"
import script from "./add-ticket.vue?vue&type=script&lang=js&"
export * from "./add-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports